import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../data/landing';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-[2px] ${className}`} aria-hidden="true" data-id="element-218" data-mp="20t9u1ltc6r58">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-gold text-gold" data-id="element-219" data-mp="1r140w8rcm3og" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-cream-2 py-14 md:py-20" aria-labelledby="testimonials-title" data-id="element-220" data-mp="1d0jjnh130fx2">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-221" data-mp="1i28uowob0tl5">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-222" data-mp="141y5rz6k1p2m">
          <div className="flex items-center justify-center gap-2" data-id="element-223" data-mp="143j1hs4lve22">
            <span className="text-[24px] font-extrabold leading-none tracking-[-0.02em] text-ink md:text-[28px]" data-id="element-224" data-mp="1839wy952uicx">
              4.9
            </span>
            <Stars data-id="element-225" data-mp="32giynerdszkm" />
            <span className="sr-only" data-id="element-226" data-mp="32h2fes5aphx2">4.9 sobre 5</span>
          </div>

          <span className="mt-4 inline-block rounded-full border border-line px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-227" data-mp="2v1b0mxakzwoh">
            Basado en 500+ hombres
          </span>

          <h2 id="testimonials-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-228" data-mp="34r48pobiltnz">
            Ellos ya empezaron a generar más atracción
          </h2>

          <p className="mx-auto mt-4 max-w-[460px] text-[13px] font-medium leading-relaxed text-ink-muted md:text-[15px]" data-id="element-229" data-mp="2c1x54ax7edvv">
            Hombres de distintos países de habla hispana ya usan el Mega Pack
            para mejorar su seguridad, sus conversaciones, sus mensajes y sus
            citas.
          </p>
        </div>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="2h08dsibriici">
          {TESTIMONIALS.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-[14px] border border-line bg-cream-soft p-5" data-id="element-231" data-mp="1crr4zg3xukv">
              <Stars data-id="element-232" data-mp="3dqxyzqcmwrf" />
              <blockquote className="mt-3 text-[12px] font-medium leading-relaxed text-ink md:text-[13px]" data-id="element-233" data-mp="3eirm50dykf2">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line/70 pt-4" data-id="element-234" data-mp="ddzwik7tcu9z">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} width={160} height={160} loading="lazy" decoding="async" className="h-9 w-9 flex-none rounded-full border border-line object-cover" data-id="element-235" data-mp="ib010qp0loyz" />
                <div className="min-w-0" data-id="element-236" data-mp="3vikyqpgm3tti">
                  <p className="text-[12px] font-bold text-ink" data-id="element-237" data-mp="3vjmlhr6zq4r2">
                    {testimonial.name}
                  </p>
                  <p className="text-[10px] font-medium text-ink-muted" data-id="element-238" data-mp="2y2xd1enjc48p">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}